import { apiCall } from '../../context/api';

export const updateUserProfile = async (token, base_url, userData) => {
  if (!token) return null;

  return apiCall(base_url, token, 'PUT', '/core/users/update-user-info', userData);
};
